<div class="tagsBox p-0050">
  <span class="field-label mb-0050 caps--light">
    <i class="fal fa-plus"></i>
    Include Responses
  </span>

  <span class="mb-0025 mt-0025 d-block color--gray--004 txt-14">
    Include when
    <button class="link p-0"
            role="switch"
            type="button"
            *ngIf="isAny(includeExcludeRules.includeRule)"
            aria-label="Click to change to having all"
            (click)="includeExcludeRules.includeRule.operator = 'include having all'">having any</button>
    <button class="link p-0"
            *ngIf="!isAny(includeExcludeRules.includeRule)"
            type="button"
            role="switch"
            aria-label="Click to change to having any"
            (click)="includeExcludeRules.includeRule.operator = 'include having any'"
            (click)="toggleIncludes(false)">having all</button>
    selected responses:
  </span>
  <app-tags-advanced-rule-input *ngIf="includeExcludeRules.includeRule"
                                [showInlineOperator]="false"
                                [(ngModel)]="includeExcludeRules.includeRule.value"
                                [campaignId]="campaignId"
                                [targetType]="targetType"></app-tags-advanced-rule-input>
</div>

<div class="tagsBox p-0050 mt-0050">
  <span class="field-label mb-0050 caps--light">
    <i class="fal fa-minus"></i>
    Exclude Responses
  </span>

  <span class="mb-0025  mt-0025 d-block color--gray--004 txt-14">
    Exclude when
    <button class="link p-0"
            role="switch"
            type="button"
            *ngIf="isAny(includeExcludeRules.excludeRule)"
            aria-label="Click to change to having all"
            (click)="includeExcludeRules.excludeRule.operator = 'exclude having all'">having any</button>
    <button class="link p-0"
            *ngIf="!isAny(includeExcludeRules.excludeRule)"
            type="button"
            role="switch"
            aria-label="Click to change to having any"
            (click)="includeExcludeRules.excludeRule.operator = 'exclude having any'"
            (click)="toggleIncludes(false)">having all</button>
    selected responses:
  </span>
  <app-tags-advanced-rule-input *ngIf="includeExcludeRules.excludeRule"
                                [showInlineOperator]="false"
                                [(ngModel)]="includeExcludeRules.excludeRule.value"
                                [campaignId]="campaignId"
                                [targetType]="targetType"></app-tags-advanced-rule-input>
</div>
